module.exports = __webpack_public_path__ + "img/Gemse.ce71c8ae.jpg";